import AuthReducer from './Auth'

export default {
  auth: AuthReducer,
}
